import React, { useEffect, useState } from 'react';

import InfoOutlined from '@mui/icons-material/InfoOutlined';

import app from '../../../app.module.css';
import banner from './messageBanners.module.css';

const _MESSAGES = {
    session_expired:
        'Your session has expired. Please sign in again.',
    session_revoked:
        'Your session was ended because your password has changed or your session was revoked. Please sign in again.',
    account_inactive:
        'Your user account does not exist in Polaris or is currently inactive. Please contact your administrator for assistance.'
};

const LogoutBanner = () => {
    const [message, setMessage] = useState('');

    useEffect(() => {
        const reason = sessionStorage.getItem('logoutReason');
        if (reason && _MESSAGES[reason]) {
            setMessage(_MESSAGES[reason]);
            sessionStorage.removeItem('logoutReason');
        }
    }, []);

    const onClose = () => setMessage('');

    return !message ? null : (
        <div
            className={`${banner.bannerWrapper} ${banner.infoWrapper} ${app.fadein}`}
            role="button" tabIndex={0} onClick={onClose}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onClose();}}>
            <InfoOutlined /> {message}
        </div>
    );
};

export default LogoutBanner;
